class ShowMoreButton extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector('button');
    // LEGENDBRIX: chốt null. Custom element được nâng cấp trước khi phần bên
    // trong nó render xong (hoặc markup đổi) thì `button` là null, và constructor
    // ném lỗi — khi đó MỌI <show-more-button> sau nó trên trang cũng chết theo.
    if (!button) return;
    button.addEventListener('click', (event) => {
      this.expandShowMore(event);
      // LEGENDBRIX: chốt null cả chuỗi. Bản gốc gọi liền
      // closest('.parent-display').querySelector(...) — thiếu tổ tiên đó là lỗi.
      const parentDisplay = event.target.closest('.parent-display');
      const nextElementToFocus = parentDisplay && parentDisplay.querySelector('.show-more-item');
      if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden')) {
        // LEGENDBRIX: chốt null. Mục tiếp theo có thể không chứa <input>
        // (bộ lọc dạng khác), khi đó .focus() trên null là lỗi.
        const input = nextElementToFocus.querySelector('input');
        if (input) input.focus();
      }
    });
  }
  expandShowMore(event) {
    // LEGENDBRIX: chốt null cả hai tầng closest. Nút nằm ngoài .parent-display
    // thì bản gốc ném lỗi và danh sách không bao giờ mở ra.
    const showMoreWrap = event.target.closest('[id^="Show-More-"]');
    const parentDisplay = showMoreWrap && showMoreWrap.closest('.parent-display');
    if (!parentDisplay) return;
    this.querySelectorAll('.label-text').forEach(element => element.classList.toggle('hidden'));
    parentDisplay.querySelectorAll('.show-more-item').forEach(item => item.classList.toggle('hidden'))
  }
}

customElements.define('show-more-button', ShowMoreButton);
